// PingCheckHandler.js
import withRouter from '../component/WithRouter.jsx';
import { connect } from 'react-redux';

import PingCheckHandler from '../component/PingCheckHandler.jsx';

import sendPingChecks from '../action/sendPingChecks.js';

const mapDispatchToProps = dispatch => {
  return {
    sendPingChecks: () => dispatch(sendPingChecks()),
  };
};

export default withRouter(connect(null, mapDispatchToProps)(PingCheckHandler));
